export const languages = ['Russian', 'Hebrew', 'English'];